import { API, Auth } from "aws-amplify"
import { GetByCustomerSpecificDiscount, GetByCustomerSpecificPrice, GetByProductBasePrice } from "../../../Layout/MutaionsAndQueries"
import { ListByProductInventoryDetails } from "../../../graphql/queries"

// Base Price API call 
export const FetchBasePrice = async ({ ProductID }) => {
    try {
        const response = await API.graphql({
            query: GetByProductBasePrice,
            variables: {
                id: ProductID
            }

        })
        // console.log("response", response)
        return {
            ...response.data.getProductPrices, Status: "BasePrice",
            ProductPrice: Math.abs(parseFloat(response.data.getProductPrices.ProductPrice)),
            ProductPriceQuantity: Math.abs(parseFloat(response.data.getProductPrices.ProductPriceQuantity)),
            ButtonStatus: "AddtoCart"
        }
    } catch (error) {
        console.error("FetchBasePrice Error", error)
        return { Status: "ErrorPrice", ButtonStatus: "Unavailable" }
    }
}

// Customer Discount API call
export const FetchDiscountDetails = async ({ ProductID }) => {
    const userDetails = await Auth.currentAuthenticatedUser();
    try {
        const response = await API.graphql({
            query: GetByCustomerSpecificDiscount,
            variables: {
                id: userDetails.signInUserSession.idToken.payload["custom:customer_UUID"] + "-" + ProductID
            }

        })
        if (response?.data?.getProductDiscounts === null || response?.data?.getProductDiscounts?.ProductDiscount === 0) {
            return { DiscountStatus: "NoDiscount" }
        }
        else if (response.data.getProductDiscounts.ProductDiscount > 0) {
            return { DiscountStatus: "Avl", DiscountPercentage: Math.abs(parseFloat(response.data.getProductDiscounts.ProductDiscount)) }
        }
    } catch (error) {
        console.error("FetchDiscountDetails Error", error);
        return { DiscountStatus: "ErrorDiscount" }
    }
}

// Customer Specific Price API call
export const FetchCustomerSpecificPrice = async ({ ProductID }) => {
    const userDetails = await Auth.currentAuthenticatedUser();
    try {
        const response = await API.graphql({
            query: GetByCustomerSpecificPrice,
            variables: {
                id: userDetails.signInUserSession.idToken.payload["custom:customer_UUID"] + "-" + ProductID
            }

        })
        if (response?.data?.getCustomerSpecificPrices === null || response?.data?.getCustomerSpecificPrices?.ProductPrice === 0) {
            return { Status: "NoCSPPrice" }
        }
        else if (response.data.getCustomerSpecificPrices.ProductPrice > 0) {
            return {
                ...response.data.getCustomerSpecificPrices, Status: "CSPPrice",
                ProductPrice: Math.abs(parseFloat(response.data.getCustomerSpecificPrices.ProductPrice)),
                ProductPriceQuantity: Math.abs(parseFloat(response.data.getCustomerSpecificPrices.ProductPriceQuantity)),
                ButtonStatus: "AddtoCart"
            }
        }

    } catch (error) {
        console.error("FetchCustomerSpecificPrice Error", error);
        return { Status: "ErrorPrice", ButtonStatus: "Unavailable" }
    }

}

//Inventory API Call
export const FetchProductStock = async ({ ProductID }) => {
    try {
        const ProductStockDetails = await API.graphql({
            query: ListByProductInventoryDetails,
            variables:
            {
                MaterialID: ProductID
            }
        })
        if (ProductStockDetails.data.ListByProductInventoryDetails.SearchResult.length > 0) {
            if (parseFloat(ProductStockDetails.data.ListByProductInventoryDetails.SearchResult[0].CalculatedAvailableStock) <= 0) {
                return { Status: "OutOfStock" }
            }
            else {
                return { Status: "InStock", Data:ProductStockDetails.data.ListByProductInventoryDetails.SearchResult[0] };
            }

        }
        else if (ProductStockDetails.data.ListByProductInventoryDetails.SearchResult.length === 0) {
            return { Status: "OutOfStock" }
        }

    }
    catch (error) {

        console.error("FetchInventoryDetails Error", error);
        return { Status: "OutOfStock" }
    }
}